module.exports = __webpack_public_path__ + "static/assets/32e95799e6d09643a626284bb83172d1.svg";